<script>
  import { setDocumentReferrer } from '../stores/referrer';
  setDocumentReferrer();
</script>
